import _implicitStylesheets from "./rootContainer.css";
import _implicitScopedStylesheets from "./rootContainer.scoped.css?scoped=true";
import _pagesError from "pages/error";
import _pagesInMaintenance from "pages/inMaintenance";
import _pagesLoggedout from "pages/loggedout";
import _pageAuthenticatedContainer from "page/authenticatedContainer";
import _appxLoadingSpinner from "appx/loadingSpinner";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "root-container": true
  },
  key: 0
};
const stc1 = {
  key: 1
};
const stc2 = {
  key: 2
};
const stc3 = {
  key: 3
};
const stc4 = {
  key: 4
};
const stc5 = {
  classMap: {
    "loading-container": true
  },
  key: 5
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element} = $api;
  return [api_element("div", stc0, [$cmp.isErrorPage ? api_custom_element("pages-error", _pagesError, stc1) : null, $cmp.isMaintenancePage ? api_custom_element("pages-in-maintenance", _pagesInMaintenance, stc2) : null, $cmp.isLoggedOutPage ? api_custom_element("pages-loggedout", _pagesLoggedout, stc3) : null, $cmp.needsAuthentication ? $cmp.isLoggedIn ? api_custom_element("page-authenticated-container", _pageAuthenticatedContainer, stc4) : null : null, $cmp.needsAuthentication ? !$cmp.isLoggedIn ? api_element("div", stc5, [api_custom_element("appx-loading-spinner", _appxLoadingSpinner, {
    props: {
      "description": $cmp.sharedLabels.authenticating,
      "showDelay": "0"
    },
    key: 6
  })]) : null : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3j36bej5i3l";
tmpl.legacyStylesheetToken = "page-rootContainer_rootContainer";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
